import Image from "next/image";
import PropTypes from "prop-types";

const ActionCards = ({ actionCardsData = {} }) => {
  const { heading = "", images = [] } = actionCardsData;
  return (
    <section className="w-full pt-8 px-4">
      <div className="max-w-screen-lg mx-auto">
        {/* PARAGRAPH */}
        <p className="text-center text-[14px] text-[#232323] mb-8 leading-[1.6] font-[HelveticaRoman,Helvetica,sans-serif]">
          {heading}
        </p>

        {/* CARDS */}
        <div className="flex justify-center items-center flex-wrap gap-3 sm:gap-6 md:gap-8">
          {images?.map((card, index) => (
            <a
              key={index}
              href={card?.fields?.src || "#"}
              target={card?.fields?.newTab ? "_blank" : "_self"}
              rel="noreferrer"
              className="flex-shrink-0 
                w-[100px]        /* mobile same */
                sm:w-[180px]     /* tablet small */
                md:w-[167px]     /* ✅ FIX for 768 */
                lg:w-[252px]     /* desktop */
                transition-transform duration-300
              "
            >
              <div
                className="
                relative w-full 
                h-[60px]         /* mobile same */
                sm:h-[110px] 
                md:h-[100px]     /* adjusted proportion for 167 width */
                lg:h-[150px]
                rounded-[20px] sm:rounded-[28px] 
                overflow-hidden
              "
              >
                <Image
                  src={card?.fields?.imageUrl}
                  alt={card?.fields?.alt || "promo"}
                  fill
                  className="object-cover"
                />
              </div>
            </a>
          ))}
        </div>
        <div
          className="pt-[40px]"
          style={{
            borderBottom: "1px solid #e8e8e8",
          }}
        ></div>
      </div>
    </section>
  );
};

ActionCards.propTypes = {
  actionCardsData: PropTypes.shape({
    heading: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.string,
        url: PropTypes.string,
        alt: PropTypes.string,
        newTab: PropTypes.bool,
      })
    ),
  }),
};

export default ActionCards;
